import * as cryptoJS from "crypto-js";
import { Secret } from "Models/secret";

export const generateTokenBySecret = (valueToEncrypt: any, secret?: Secret) => {
  if (!secret?.SECRET_KEY_PASSWORD || !valueToEncrypt) return;

  return cryptoJS.AES.encrypt(
    JSON.stringify(valueToEncrypt),
    secret.SECRET_KEY_PASSWORD
  ).toString();
};
